import React from "react";
import PaginationModified from "../../../data/PaginationModified";
import { convertThenFormat, formatDateTime } from "../../common-data/Converts";

const LeadLogsValue = ({ tableData, tablePagination, isPage, setIsPage }) => {
  function getPagination() {
    try {
      const pagination = tablePagination ? tablePagination : [];
      return pagination;
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <div className="all-leads-log mt30">
      {tableData?.length > 0 &&
        tableData.map((lead, index) => {
          return (
            <div className="log-card" key={index}>
              <div
                className="all-info"
                style={{
                  padding: "20px",
                }}
              >
                <div
                  className="log-card-top"
                  style={{
                    padding: "0",
                  }}
                >
                  <h3 className="lead-name">{lead?.name || "NA"}</h3>
                </div>

                <div
                  className="card-other-info"
                  style={{
                    padding: "0",
                    marginTop: "15px",
                  }}
                >
                  <span className="value semi-bold">
                    {lead?.mobile || "NA"}
                  </span>
                  {lead?.email ? (
                    <span className="value email semi-bold">
                      {lead?.email || "NA"}
                    </span>
                  ) : null}
                  <span className="value semi-bold">
                    {lead?.gym_name || "NA"}
                  </span>
                </div>

                <div
                  className="all-hidden-logs"
                  style={{
                    padding: "0",
                    marginTop: "15px",
                  }}
                >
                  <span className="value">
                    Date Added -{" "}
                    {lead?.date_added ? formatDateTime(lead.date_added) : "-"}
                  </span>

                  <span className="value">
                    Amount - ₹{convertThenFormat(lead?.price || 0)}
                  </span>

                  <span className="value">
                    plan - {lead?.plan_name || "NA"}
                  </span>

                  <span className="value">
                    lead added on -{" "}
                    {lead?.lead_added_on
                      ? formatDateTime(lead.lead_added_on)
                      : "-"}
                  </span>
                </div>
              </div>
            </div>
          );
        })}

      <div className="lead-logs-card-pagination">
        <PaginationModified
          isPage={isPage}
          onChangePage={setIsPage}
          pagination={getPagination()}
        />
      </div>
    </div>
  );
};

export default LeadLogsValue;
